import { render, staticRenderFns } from "./NetflixIcon.vue?vue&type=template&id=6c8ffad4&"
import script from "./NetflixIcon.vue?vue&type=script&lang=js&"
export * from "./NetflixIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports